<template>
    <div class="cartTable">
        <va-card :title="$t('order.cart.cart')" :class="{disabled: orderStatus != 0}">
            <va-data-table
            :fields="fields"
            :data="items"
            >
                <template slot="preview" slot-scope="props">
                    <img v-if="props.rowData.product.images && props.rowData.product.images.length > 0" :src="replaceUrl(props.rowData.product.images[0].file)" class="data-table-server-pagination---avatar">
                </template>
                <template slot="product.title" slot-scope="props">
                    <a :href="'https://www.apicolturaboni.it/product/'+props.rowData.product.slug" target="_blank">{{props.rowData.product.title}}</a>
                </template>
                <template slot="product.prices.net_value" slot-scope="props">
                    <div class="priceStatic" v-html="$formatPrice($dbNormalizePrice(netValue(props.rowData)))"></div>
                </template>
                <template slot="product.tax" slot-scope="props">
                    <div class="priceStatic">{{props.rowData.product.tax}}%</div>
                </template>
                <template slot="product.prices.gross_value" slot-scope="props">
                    <va-input
                    type="number"
                    v-model="props.rowData.product.prices.gross_value"
                    />
                </template>
                <template slot="quantity" slot-scope="props">
                    <va-input
                    type="number"
                    v-model="props.rowData.quantity"
                    />
                </template>
                <template slot="subTotal" slot-scope="props">
                    <div class="priceStatic" v-html="$formatPrice($dbNormalizePrice(props.rowData.quantity * props.rowData.product.prices.gross_value))"></div>
                </template>
                <template slot="product.prices.discount" slot-scope="props">
                    <va-input
                    type="number"
                    v-model="props.rowData.product.prices.discount"
                    />
                </template>
                <template slot="totalCalculatedParsed" slot-scope="props">
                    <div class="priceStatic"  v-html="$formatPrice($dbNormalizePrice(totalRowPrice(props.rowData)))"></div>
                </template>
                <template slot="actions" slot-scope="props" v-if="orderStatus == 0">
                    <va-button class="ma-0" flat small icon="fa fa-trash" color="danger" @click.prevent="deleteCartItem(props.rowData.product)" type="button">{{$t('order.cart.deleteItem')}}</va-button>
                </template>
            </va-data-table>

            <div class="my-4"></div>
            <div class="row">
                <div class="flex md2 sm6 xs12">
                    <div class="va-card__header-title" :style="{color: $themes.info}"> {{$t('tables.headings.totalPriceCart')}} </div>
                </div>
                <div class="flex md3 sm6 xs12">
                    <div class="numberPadding" v-html="$formatPrice($dbNormalizePrice(totalCartPrice))"></div>
                </div>
            </div>
            <div class="row">
                <div class="flex md2 sm6 xs12">
                    <div class="va-card__header-title" :style="{color: $themes.info}"> {{$t('tables.headings.shippingPrice')}} </div>
                </div>
                <div class="flex md3 sm6 xs12">
                    <va-input
                    type="number"
                    v-model="shippingPrice.value"
                    :error="shippingPrice.error"
                    />
                </div>
            </div>
            <div class="row">
                <div class="flex md2 sm6 xs12">
                    <div class="va-card__header-title" :style="{color: $themes.info}"> {{$t('tables.headings.fee')}} </div>
                </div>
                <div class="flex md3 sm6 xs12">
                    <va-input
                    type="number"
                    v-model="paymentMethodFee.value"
                    :error="paymentMethodFee.error"
                    />
                </div>
            </div>
            <div class="row">
                <div class="flex md2 sm6 xs12">
                    <div class="va-card__header-title" :style="{color: $themes.info}"> {{$t('tables.headings.totalDiscount')}} </div>
                </div>
                <div class="flex md3 sm6 xs12">
                    <va-input
                    type="number"
                    v-model="totalDiscount"
                    />
                </div>
            </div>
            <div class="row">
                <div class="flex md5 sm6 xs12 separator" :style="{backgroundColor: $themes.dark}"></div>
            </div>
            <div class="row">
                <div class="flex md2 sm6 xs12">
                    <div class="va-card__header-title" :style="{color: $themes.info}"> {{$t('tables.headings.orderPrice')}} </div>
                </div>
                <div class="flex md3 sm6 xs12">
                    <div class="numberPadding" v-html="$formatPrice($dbNormalizePrice(totalOrderPrice))"></div>
                </div>
            </div>
            <va-modal v-model='showModalDeleteCartItem' size='small' :title=" $t('order.modal.deleteCartItemTitle')" :message=" $t('order.modal.deleteCartItem') " :oktext="$t('modal.confirm') " :canceltext="$t('modal.cancel') " @ok='proceedDeleteCartItem' @cancel='abortDeleteProduct'/>
        </va-card>
    </div>
</template>

<script>
import axios from 'axios';


export default {
    props: ['orderStatus', 'order'],
    data (){
        return {
            fields: [
                {
                    name: '__slot:preview',
                    title: this.$t('tables.headings.preview'),
                    width: '10%',
                }, 
                {
                    name: '__slot:product.title',
                    title: this.$t('tables.headings.title'),
                    width: '25%',
                }, 
                {
                    name: '__slot:product.prices.net_value',
                    title: this.$t('tables.headings.singlePrice'),
                    width: '8%',
                },
                {
                    name: '__slot:product.tax',
                    title: this.$t('tables.headings.orderTax'),
                    width: '8%',
                },
                {
                    name: '__slot:product.prices.gross_value',
                    title: this.$t('tables.headings.grossValue'),
                    width: '8%',
                },
                {
                    name: '__slot:quantity',
                    title: this.$t('tables.headings.quantity'),
                    width: '8%',
                },
                {
                    name: '__slot:subTotal',
                    title: this.$t('tables.headings.subTotal'),
                    width: '8%',
                }, 
                {
                    name: '__slot:product.prices.discount',
                    title: this.$t('tables.headings.discount'),
                    width: '8%',
                }, 
                {
                    name: '__slot:totalCalculatedParsed',
                    title: this.$t('tables.headings.totalPrice'),
                    width: '8%',
                },
                {
                    name: '__slot:actions',
                    width: '9%',
                    dataClass: 'text-center',
                }
            ],
            shippingPrice: {value: 0 , error: false},
            paymentMethodFee: {value: 0 , error: false},
            showModalDeleteCartItem: false,
            saveChanges: false,
            init: true,
            totalDiscount: 0,
            items: [],
            replaceUrl(u){
                return u.replace('https://a.storyblok.com','https://api.apicolturaboni.it/imgprox')
            }
        }
    },
    created(){
        this.items = this.order.items;
        this.shippingPrice.value = this.order.shipping_price ? this.$normalizePrice(this.order.shipping_price) : 0;
        this.paymentMethodFee.value= this.order.payment_method_fee? this.$normalizePrice(this.order.payment_method_fee) : 0;
        this.totalDiscount = this.order.total_discount ? this.$normalizePrice(this.order.total_discount) : 0;
        for(var i in this.items){
            if(this.items[i].product.prices.length){
                var price = null;
                for(var j in this.items[i].product.prices){
                    if(this.items[i].quantity >= this.items[i].product.prices[j].from_quantity){
                        price = this.items[i].product.prices[j];
                    }
                }
                this.items[i].product.prices = price ? price : this.items[i].product.prices[0] ;
            }
            this.items[i].product.tax = this.$normalizePrice(this.items[i].product.tax);
            this.items[i].product.prices.gross_value = this.$normalizePrice(this.items[i].product.prices.gross_value);
            this.items[i].product.prices.net_value = this.$normalizePrice(this.items[i].product.prices.net_value);
        }
        this.$nextTick(()=>{
            this.init = false;
        })
    },
    computed:{
        totalCartPrice(){
            var total = 0;
            for(var i in this.items){ 
                total += this.totalRowPrice(this.items[i]);
            }
            return total;
        },
        totalOrderPrice(){
            var discount = isNaN(this.totalDiscount) || this.totalDiscount == '' ? 0 : this.totalDiscount;
            var shippingPrice = isNaN(this.shippingPrice.value) || this.shippingPrice.value == '' ? 0 : this.shippingPrice.value;
            const method_fee = isNaN(this.paymentMethodFee.value) || this.paymentMethodFee.value == '' ? 0 : this.paymentMethodFee.value;
            return this.totalCartPrice + parseFloat(method_fee) + parseFloat(shippingPrice) - parseFloat(discount);
        },
        totalCartTaxes(){
            var total = 0;
            for(var i in this.items){ 
                total += this.items[i].quantity * this.items[i].product.prices.net_value * this.items[i].product.tax / 100
            }
            return total;
        },
    },
    watch: {
        items:{
            deep:true,
            handler(t,f){
                if(!this.init){
                    this.saveChanges = true;
                }
            }
        },
        shippingPrice:{
            deep: true,
            handler(t,f){
                if(!this.init){
                    this.saveChanges = true;
                }
            }
        },
        totalDiscount(t,f){
            if(!this.init){
                this.saveChanges = true;
            }
        }
    },
    methods: {
        deleteCartItem(row){
            this.tempItemToDelete = row.uuid;
            this.showModalDeleteCartItem = true;
        },
        proceedDeleteCartItem(){
            for(var i in this.items){
                if(this.items[i].product.uuid == this.tempItemToDelete){
                    this.items.splice(i, 1);
                    break;
                }
            }
        },
        abortDeleteProduct(){
            this.tempItemToDelete = null;
        },
        grossValue(row, ammount){
            var net = ammount || ammount === 0 ? ammount : row.product.prices.net_value;
            return parseFloat(net) + parseFloat(net * row.product.tax / 100)
        },
        netValue(row, ammount){
            var gross = ammount || ammount === 0 ? ammount : row.product.prices.gross_value;
            return parseFloat(gross / parseFloat('1.'+row.product.tax));
        },
        totalRowPrice(row){
            var net = this.netValue(row);
            var discount = (net * row.product.prices.discount / 100);
            var discountedNet = net - discount;
            var totalNet = row.quantity * discountedNet;
            return this.grossValue(row, totalNet);
        },
        saveCart(){
            var parsedItems = [];
            for(var i in this.items){
                parsedItems.push(JSON.parse(JSON.stringify(this.items[i])));
                parsedItems[i].product.prices.discount = this.$dbNormalizePrice(parsedItems[i].product.prices.discount);
                parsedItems[i].product.prices.net_value = this.$dbNormalizePrice(this.netValue(parsedItems[i]));
                parsedItems[i].product.prices.gross_value = this.$dbNormalizePrice(parsedItems[i].product.prices.gross_value);
                parsedItems[i].product.tax = this.$dbNormalizePrice(parsedItems[i].product.tax)
            }
            return this.$axios.put('api/orders/updateCartOrder',{
                items: parsedItems,
                orderUuid: this.order.uuid,
                subTotal: this.$dbNormalizePrice(this.totalCartPrice),
                total: this.$dbNormalizePrice(this.totalOrderPrice),
                shipping: this.$dbNormalizePrice(this.shippingPrice.value),
                payment_method_fee: this.$dbNormalizePrice(this.paymentMethodFee.value),
                totalCartTaxes: this.$dbNormalizePrice(this.totalCartTaxes),
                totalDiscount: this.$dbNormalizePrice(this.totalDiscount),
            })
            .then(axRes => {
                this.showToast(
                    this.$t('order.cart.saveCartComplete'),
                    {
                        icon:'fa-check',
                        position: 'bottom-right',
                        duration: 5000,
                        fullWidth: false,
                        className: 'vuestic-toast'
                    },
                )
                return true;
            }).catch(axErr => {
                this.showToast(
                    this.$t('order.cart.saveErrorCart'),
                    {
                        icon:'fa-warning',
                        position: 'bottom-right',
                        duration: 5000,
                        fullWidth: false,
                        className: 'vuestic-toast'
                    },
                )
                return false;
            })
        }
    },
}
</script>

<style lang="scss">
    .data-table-server-pagination---avatar {
        width: 70px;
    }
    .numberPadding{
        padding: 0 0.5rem;
    }
    .separator{
        margin: 0;
        margin-bottom: 1em;
        padding: 0!important;
        height: 1px;
    }
    .priceStatic{
        margin-bottom: 1rem;
        padding: 0.25rem 0.5rem;
        box-sizing: border-box;
        line-height: 1.5rem;
    }
    .justifyRight{
        margin-right: 0;
        margin-left: auto;
    }
</style>
